var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "select"
    ? _c("div", {
        staticClass: "select",
        attrs: { loading: "", title: _vm.title },
        on: { click: _vm.click }
      })
    : _c("transition", { attrs: { name: "collapse" } }, [
        _vm.cells === undefined
          ? _c("div", {
              attrs: { loading: "", title: _vm.title },
              on: { click: _vm.click }
            })
          : _c("td", { attrs: { colspan: _vm.cells, loading: "" } }, [
              _c("div", {
                attrs: { title: _vm.title },
                on: { click: _vm.click }
              })
            ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }